function removeInnerProp(props) {
    var innerProps = ['page', '__ob__'];
    if (props) {
        for (var itemProp in innerProps) {
            var index = props.indexOf(innerProps[itemProp]);
            if (index > -1) {
                props.splice(index, 1);
            }
        }
    }
    return props;
}
export function isEquivalent(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    aProps = removeInnerProp(aProps);
    bProps = removeInnerProp(bProps);
    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    // If we made it this far, objects
    // are considered equivalent
    return true;
}
